import { colors } from './colors';
var palette = {
  primary: {
    main: colors.WomCTA
  },
  secondary: {
    main: colors.WomCorp
  },
  error: {
    main: colors.NotificacionesRojo
  },
  warning: {
    main: colors.NotificacionesAmarillo
  },
  info: {
    main: colors.WomCTA
  },
  success: {
    main: colors.NotificacionesVerde
  },
  text: {
    primary: colors.Neutros90,
    secondary: colors.Neutros90,
    disabled: colors.NeutrosDeshabilitado
  },
  action: {
    disabledBackground: colors.Neutros20,
    disabled: colors.Neutros0
  }
};
export { palette };